













































/**
 * External dependencies.
 */
import { Component, Inject, Vue } from 'vue-property-decorator'

/**
 * Internal dependencies.
 */
import { lazyInject } from '@/container'
import { TYPES } from '@/types'
import Badges from '@/components/ui/Badges.vue'
import ContestPhotos from '@/components/account/ContestPhotos.vue'
// import AdSense from '@/components/ui/AdSense.vue'
import { namespace as commonModule } from '@/store/common'
import { Modes } from '@/store/common/enum/Modes'

@Component({
  components: {
    Badges,
    ContestPhotos
    // AdSense
  }
})
export default class AccountPhotos extends Vue {
  @Inject() readonly swapToDefaultComponent!: () => void

  @lazyInject(TYPES.PhotoService)
  PhotoService: any

  @lazyInject(TYPES.AdService)
  AdService: any

  @lazyInject(TYPES.AuthService)
  AuthService: any

  user: any = null
  likesCount: number | string = 0
  adsForSlides: Array<any> = []
  contestPhotos: Array<any> = []
  photosLoading: boolean = false
  noPhotos: boolean = false
  badges: string[] = []

  @commonModule.Getter getMode: Modes

  get isModeOpen () {
    return this.getMode === Modes.OPEN
  }

  created () {
    this.photosLoading = true
    this.user = this.AuthService.getAuthUser()

    this.badges = this.user.badges

    this.AdService.getAds({ location: 'my_photos' })
      .then((response: any) => {
        this.adsForSlides = response.data
      })

    this.PhotoService.getUserPhotos(this.user.id, null, true)
      .then((response: any) => {
        this.contestPhotos = response.data
        this.photosLoading = false

        if (!this.contestPhotos || this.contestPhotos.length === 0) {
          this.noPhotos = true
        }

        this.contestPhotos.forEach((photo: any) => {
          this.likesCount += photo.likes_count
        })
      })
  }

  loading (isLoading: boolean) {
    // event emitted from child
    this.photosLoading = isLoading
  }
}
